/**
 * The `tenancyNodeId` claim of an access token — the MLM node THIS BO session
 * is operating as (the company root for a normal admin, or the impersonated
 * senior/master/agent). Returns null when the claim is absent or the token is
 * malformed.
 */
export function selfNodeId(token: string | null): string | null {
  if (!token) return null;
  try {
    const part = token.split('.')[1];
    if (!part) return null;
    const claims = JSON.parse(
      atob(part.replace(/-/g, '+').replace(/_/g, '/')),
    ) as { tenancyNodeId?: string | null };
    return claims.tenancyNodeId ?? null;
  } catch {
    return null;
  }
}
